/**
 * Inline Creation Schema — V1 Entities (PIU / Sub-PIU)
 *
 * Used for inline creation during the resolution step when an entity
 * reference can't be matched. POSTs to the V1 /entities endpoint.
 * Not a bulk-uploadable entity type — only used for inline creation.
 *
 * Parent entities referenced by beneficiaries and suppliers are PIU or SUB_PIU;
 * other entity types (SUPPLIER, BENEFICIARY, etc.) are created via their own
 * dedicated bulk upload schemas.
 */

import { UploadSchema } from '../types';

export const v1EntitySchema: UploadSchema = {
	entityType: 'v1Entity',
	label: 'Entity',
	apiEndpoint: '/v1/entities',
	apiMethod: 'POST',
	payloadTransform: (formValues, projectId) => ({
		name: formValues.name,
		type: formValues.type || 'PIU',
		isKycVerified: true,
		project: projectId,
	}),
	fields: [
		{
			name: 'name',
			label: 'Entity Name',
			dataType: 'string',
			required: true,
			headerAliases: ['Entity Name', 'PIU', 'Organization'],
		},
		{
			name: 'type',
			label: 'Entity Type',
			dataType: 'enum',
			required: false,
			enumValues: [
				'PIU',
				'SUB_PIU',
				'INTERMEDIARY',
				'AUDITOR',
				'BORROWER',
				'DONOR',
				'TAX_AUTHORITY',
			] as const,
			defaultValue: 'PIU',
		},
	],
};
